import React, { Component } from "react";
import Visualizer from "../Visualizer/Visualizer";
import PlayerControl from "../PlayerControl/PlayerControl";
import { getComponentContent } from "../../helpers";
const playIcon = process.env.REACT_APP_IMAGES_ROOT + "ssc-play-2.png";
const stopIcon = process.env.REACT_APP_IMAGES_ROOT + "SSC-stop.png";
const pauseIcon = process.env.REACT_APP_IMAGES_ROOT + "SSC-pause.png";
const replayIcon = process.env.REACT_APP_IMAGES_ROOT + "SSC-replay.png";

let audioTimer, countdownTimer;

class AudioPlayer extends Component {
  constructor() {
    super();
    this.state = {
      countdown: 4,
      paused: true,
      audioTimerStarted: false,
      currentTime: 0
    };
    this.setupAudioHandlers = this.setupAudioHandlers.bind(this);
    this.handleKeypress = this.handleKeypress.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.onPause = this.onPause.bind(this);
    this.onEnd = this.onEnd.bind(this);
    this.reset = this.reset.bind(this);
    this.handlePlayPauseClick = this.handlePlayPauseClick.bind(this);
    this.handleStopClick = this.handleStopClick.bind(this);
    this.handleReplayClick = this.handleReplayClick.bind(this);
    this.startAudioTimer = this.startAudioTimer.bind(this);
    this.content = getComponentContent("AudioPlayer");
  }

  componentWillMount() {
    document.addEventListener("keydown", this.handleKeypress);
  }

  componentDidMount() {
    this.setupAudioHandlers();
  }

  componentWillUnmount() {
    this.props.audio.stop();
    this.props.audio.off("play");
    this.props.audio.off("pause");
    this.props.audio.off("end");
    clearInterval(countdownTimer);
    clearInterval(audioTimer);
    document.removeEventListener("keydown", this.handleKeypress);
  }

  setupAudioHandlers() {
    this.props.audio.on("play", this.onPlay);
    this.props.audio.on("pause", this.onPause);
    this.props.audio.on("end", this.onEnd);
  }

  handleKeypress(e) {
    e.preventDefault();
    if (e.keyCode === 32) {
      this.handlePlayPauseClick();
    }
  }

  onPlay() {
    if (!this.state.audioTimerStarted) {
      this.setState({ audioTimerStarted: true });
      this.startAudioTimer();
    }
    this.setState({ paused: false });
  }

  onPause() {
    this.setState({ paused: true });
  }

  onEnd() {
    this.props.audio.pause();
    clearInterval(audioTimer);
    this.setState({ currentTime: this.props.audioDuration });
  }

  reset() {
    this.props.audio.stop();
    clearInterval(countdownTimer);
    clearInterval(audioTimer);
    this.setState({
      audioTimerStarted: false,
      paused: true,
      currentTime: 0,
      countdown: 4
    });
  }

  handlePlayPauseClick(event) {
    console.log("handlePlayPauseClick");
    this.props.checkAudioRefusedToPlay();
    if (event && event.currentTarget.classList.contains("control-disabled")) {
      return;
    }

    if (this.state.countdown === 4) {
      this.startCountdown();
    }

    if (
      this.state.currentTime === this.props.audioDuration &&
      this.props.audioDuration !== 0
    ) {
      this.handleReplayClick();
    } else {
      if (this.state.paused) {
        this.props.audio.play();
      } else {
        this.props.audio.pause();
      }
    }
  }

  handleStopClick(event) {
    if (event && event.currentTarget.classList.contains("control-disabled")) {
      return;
    }
    this.reset();
  }

  handleReplayClick(event) {
    if (event && event.currentTarget.classList.contains("control-disabled")) {
      return;
    }
    this.reset();
    //react needs a timeout for setState to apply
    setTimeout(() => {
      this.handlePlayPauseClick();
    }, 25);
  }

  startCountdown() {
    this.setState({ countdown: 3.97 });
    clearInterval(countdownTimer);
    countdownTimer = setInterval(() => {
      if (!this.state.paused || !this.state.audioTimerStarted) {
        this.setState({ countdown: this.state.countdown - 0.03 });
        if (this.state.countdown < 1) {
          //skip to end to test end state
          //this.props.audio.seek(this.props.audioDuration - 10);
          clearInterval(countdownTimer);
        }
      }
    }, 100);
  }

  startAudioTimer() {
    clearInterval(audioTimer);
    audioTimer = setInterval(() => {
      if (!this.state.paused) {
        this.setState({ currentTime: Math.floor(this.props.audio.seek()) });
      }
    }, 1000);
  }

  render() {
    return (
      <div className="ssc__audio-player">
        <Visualizer
          countdown={this.state.countdown}
          paused={this.state.paused}
          togglePlayPause={this.handlePlayPauseClick}
          currentTime={this.state.currentTime}
          duration={this.props.audioDuration}
          reset={this.state.reset}
          loaded={this.props.loaded}
        />
        <div className="ssc__audio-player__controls">
          <PlayerControl
            imgSrc={this.state.paused ? playIcon : pauseIcon}
            label={this.state.paused ? this.content.play : this.content.pause}
            onClick={this.handlePlayPauseClick}
            disabled={
              !this.props.loaded ||
              this.state.currentTime === this.props.audioDuration
            }
          />
          <PlayerControl
            imgSrc={stopIcon}
            label={this.content.stop}
            onClick={this.handleStopClick}
            disabled={
              this.state.countdown === 4 ||
              this.state.currentTime === this.props.audioDuration
            }
          />
          <PlayerControl
            imgSrc={replayIcon}
            label={this.content.replay}
            onClick={this.handleReplayClick}
            disabled={this.state.countdown === 4}
          />
        </div>
      </div>
    );
  }
}

export default AudioPlayer;



// WEBPACK FOOTER //
// ./src/components/AudioPlayer/AudioPlayer.js